import { ActivatedRoute } from '@angular/router';

import { loadStringFilterFromGetParams } from '../utils';

export enum SavedReportViewReportType {
    totalRevenue = 'TORE',
    membershipRevenue = 'MERE',
    entryPassRevenue = 'EPRE',
    eventRevenue = 'EVRE',
    voucherPackRevenue = 'VPRE',
    memberAncillaryRevenue = 'MARE',
    payments = 'PAYM',
    refunds = 'REF',
    discountUsageLogs = 'DISU',
    accountingTotals = 'ACCT',
    quickbooksDesktopExport = 'QBDE',
    newCustomers = 'NEWC',
    customerRetentionRate = 'CRET',
    productMembershipConversionRate = 'PMCR',
    newCustomerMembershipConversionRate = 'NCCR',
    customerCheckInCountsInDateRange = 'CCID',
    activityLog = 'ALOG',
    customerMemberships = 'CMS',
    members = 'MEM',
    rosterMembers = 'RMEM',
    entryPasses = 'EPS',
    membershipsSetToCancel = 'MSTC',
    membershipsSetToFreeze = 'MSTF',
    membershipCancellationLogs = 'MCLS',
    membershipFreezeLogs = 'MFLS',
    newMembershipsOverTime = 'NMOT',
    newEntryPassesOverTime = 'NEOT',
    membershipCountsOverTime = 'MCOT',
    membershipAddOnCountsOverTime = 'MACT',
    membershipAges = 'MAGE',
    membershipConversionTimes = 'MCTS',
    memberChurnRate = 'MCR',
    memberAncillarySpendRate = 'MASP',
    ancillaryRevenueByMember = 'ARBM',
    giftLog = 'GIFT',
    membershipReferralCounts = 'MRCS',
    membershipReferralLog = 'MRL',
    membersByTypeAndHomeLocation = 'MBTH',
    bookings = 'BOOK',
    reservations = 'RES',
    eventBookingsOverTime = 'EBOT',
    eventVouchers = 'EVVO',
    checkInCounts = 'CIC',
    uniqueCheckInCounts = 'UCIC',
    checkIns = 'CKIN',
    challengeParticipantList = 'CPL',
    staffTimesheet = 'STIM',
    customers = 'CUST',
    redemptionCodes = 'RCOD',
    customInboxItems = 'CINB',
    documents = 'DOCS',
}

export interface SavedReportView {
  id: number;
  url: string;
  report_type: SavedReportViewReportType;
  name: string;
  columns: string[];
  filters: any;
  created_by_id: number;
  created_by_first_name: string;
  created_by_last_name: string;
  created_by_email: string;
  last_updated_by_id: number;
  last_updated_by_first_name: string;
  last_updated_by_last_name: string;
  last_updated_by_email: string;
  created_at: string;
  updated_at: string;
}

export interface SavedReportViewFilters {
  report_type?: SavedReportViewReportType;
}

export function loadSavedReportViewFiltersFromGetParams(activatedRoute: ActivatedRoute): SavedReportViewFilters {
  const filters: SavedReportViewFilters = {};

  const initialQPs = activatedRoute.snapshot.queryParamMap;

  loadStringFilterFromGetParams(filters, 'report_type', initialQPs);

  return filters;
}
